<template lang="html">
  <div class="card shadow" @mouseover="cardMouseover" @mouseout="cardMouseout" @click.stop="cardClick" :class="{ highlight: highlight || card.highlight, editing: editing, updating: updating, full: full }">
    <!-- <ibutton class="cardDrag" icon="arrows" text=""></ibutton> -->
    <div class="buttons-top-right">
      <ibutton v-if="!editing" class="left" icon="plus" text="Add" :click="createCard"></ibutton>
      <ibutton v-if="!editing" class="right" icon="pencil" text="Edit" :click="editCard"></ibutton>
      <ibutton v-if="editing" class="left cancel" icon="close" text="Cancel" :click="cancelEdit"></ibutton>
      <ibutton v-if="editing" class="right save" icon="check" text="Save" :click="saveEdit"></ibutton>
      <button class="copy" type="button" @click.stop="copy" v-clipboard="fullText"><img class="icon" :src="copyIcon">Copy</button>
    </div>
    <div class="main" v-if="(full && card.highlight) || card.content.title || card.content.description">
      <div class="label" v-if="full && card.highlight"><span class="top-hit" v-if="card.highlight"><icon name="bolt"></icon> Top Hit</span><span class="type"><!--<icon name="clock-o"></icon> Memory--></span></div>
      <div class="content" @click="linkClick">
        <editable-markdown v-if="card.content.title || editing" :content="card.content.title" :editable="editing" @update="card.content.title = $event" placeholder="Title" class="title"></editable-markdown>
        <editable-markdown :content="text" :editable="editing" @update="text = $event" :style="{'font-size': fontSize }"></editable-markdown>
        <draggable v-model="listCards" :options="{ disabled: !editing, handle: '.drag', draggable: '.cardlet' }" class="list" v-if="listCards.length || editing">
          <cardlet v-for="item in listCards" :editing="editing" :card="item" :key="item.objectID" @cardletClick="cardletClick" @remove="removeListItem"></cardlet>
          <section class="buttons" v-if="editing">
            <!-- <ibutton class="left" icon="plus" text="Create List Item" :click="addListItem"></ibutton>
            <ibutton class="right" icon="search" text="Insert Card Into List" :click="toggleListSearch" :class="{selected: showListSearch}"></ibutton> -->
            <search v-if="showListSearch" @select="addListItem" :allCards="allCards" :setCard="setCard" :auth="auth"></search>
          </section>
        </draggable>
        <img v-if="full && card.attachments && card.attachments[0]" v-bind:src="card.attachments[0].url">
      </div>
      <div v-if="full && card.pending" class="pending">
        <i>This card has changes pending review</i> <ibutton icon="eye" text="Show Pending Changes" :click="togglePending" class="small"></ibutton>
        <div v-if="showPending">
          <b>Pending:</b><br>
          {{card.pending[0].description}}
        </div>
      </div>
      <p class="spinner" v-if="!card"><icon name="refresh" class="fa-spin fa-3x"></icon></p>
      <p class="extractedFrom" v-if="full && card.extractedFrom">Extracted from <a v-bind:href="card.extractedFrom.url" target="_blank">{{card.extractedFrom.title}}</a></p>
    </div>
    <a v-if="card.files" v-for="file, i in card.files" class="file" target="_blank" :href="file.url || 'https://docs.google.com/document/d/15WQ-3weCzF7kmi9FzMJwN6XH1K_ly6cvBM_NuFZtJsw/edit?usp=sharing'">
      <img :src="fileIcons[i]" alt="">
      <h4><vue-markdown :watches="['card.files']" :source="file.title" :linkify="false" :anchorAttributes="{target: '_blank'}"></vue-markdown></h4>
      <h5>📂 {{file.folder || auth && auth.user && auth.user.data && auth.user.data.organisation && auth.user.data.organisation.id + ' Drive' || 'Explaain Drive'}}</h5>
    </a>
    <footer v-if="full">
      <div class="sources" v-if="card.sources && card.sources.length">
        Source{{card.sources.length > 1 ? 's' : ''}}: <span v-for="source, i in card.sources"><a :href="source.url" target="_blank">{{source.name}}</a>{{i < card.sources.length - 1 ? ', ' : '' }}</span>
      </div>
      <!-- <div class="buttons" v-if="!editing">
        <ibutton class="left delete" icon="trash" text="Delete" :click="deleteCard"></ibutton>
        <ibutton class="right edit" icon="pencil" text="Edit" :click="editCard"></ibutton>
      </div>
      <div class="buttons" v-if="editing">
        <ibutton class="left cancel" icon="close" text="Cancel" :click="cancelEdit"></ibutton>
        <ibutton class="right save" icon="check" text="Save" :click="saveEdit"></ibutton>
      </div> -->
      <div class="buttons reaction" v-if="!reacted && !explaain">
        <p>How well did this match what you were looking for?</p>
        <button class="" @click="reaction('great')">😍</button>
        <button class="" @click="reaction('ok')">😐</button>
        <button class="" @click="reaction('bad')">😢</button>
      </div>
      <div class="buttons reaction" v-if="reacted && !explaain">
        <p>Thanks for letting us know! Our AI uses this feedback to get smarter 😎</p>
      </div>
      <div class="footer-logo">{{explaain ? 'Explaain' : 'Savvy'}}</div>
    </footer>
    <ibutton class="approve" v-if="pendingApproval" icon="check" text="Approve"></ibutton>
  </div>
</template>

<script>
import Vue from 'vue'
import log from 'loglevel'
// import _ from 'lodash'
import Clipboards from 'vue-clipboards'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'
import VueMarkdown from 'vue-markdown'
import Draggable from 'vuedraggable'
import IconButton from './ibutton.vue'
import Cardlet from './cardlet.vue'
import Editable from './editable.vue'
import EditableMarkdown from './editable-markdown.vue'
import Search from './search.vue'

Vue.use(Clipboards)

export default {
  props: [
    'explaain',
    'plugin',
    'data',
    'full',
    'allCards',
    'setCard',
    'auth',
    'pendingApproval',
    'position',
    'highlight'
  ],
  components: {
    Icon,
    VueMarkdown,
    ibutton: IconButton,
    Cardlet,
    Editable,
    Draggable,
    Search,
    EditableMarkdown
  },
  data: function() {
    return {
      card: {},
      tempListCards: {},
      editing: false,
      copyIcon: this.plugin ? './images/clipboard.svg' : './static/images/clipboard.svg',
      showListSearch: false,
      showPending: false,
      reacted: false
    }
  },
  computed: {
    updating: function() {
      return this.card.updating || false
    },
    listCards: function() {
      const self = this
      const listCards = (self.card._highlightResult && self.card._highlightResult.listCards) || self.card.listCards || []
      return listCards.map((content, i) => {
        return {
          objectID: self.card.listItems[i],
          content: {
            description: content.value || content
          }
        }
      })
    },
    // listCards: {
    //   get: function() {
    //     const self = this
    //     return self.card.content.listItems ? self.card.content.listItems.map(function(objectID) {
    //       return self.tempListCards[objectID] || JSON.parse(JSON.stringify(self.allCards[objectID] || null)) || { content: { description: 'Card Not Found' } }
    //     }) : []
    //   },
    //   set: function(newValue) { // Doesn't get called for deep events which could cause issues
    //     const self = this
    //     self.card.content.listItems = newValue.map(function(listCard) {
    //       self.tempListCards[listCard.objectID] = listCard // Is having this here good practice?
    //       return listCard.objectID
    //     })
    //   }
    // },
    text: {
      get: function() {
        const text = this.card.content.description || ''
        // if (!text || !text.length) console.log(text)
        const snippetLength = 100
        const snippetStart = Math.max(text.indexOf('**') - (snippetLength / 2), 0)
        return this.full ? text : text.trunc(snippetStart, snippetLength, true)
      },
      set: function(val) {
        this.card.content.description = val
      }
    },
    fileIcons: function() {
      return this.card.files.map(file => {
        switch (file.mimeType) {
          case 'application/vnd.google-apps.document':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'https://lh4.ggpht.com/-wROmWQVYTcjs3G6H0lYkBK2nPGYsY75Ik2IXTmOO2Oo0SMgbDtnF0eqz-BRR1hRQg=w300'
          case 'application/vnd.google-apps.spreadsheet':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'http://icons.iconarchive.com/icons/dtafalonso/android-lollipop/512/Sheets-icon.png'
          case 'application/vnd.google-apps.presentation':
          case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'http://cliparting.com/wp-content/uploads/2017/07/Google-slides-icon-free-download-at-icons8-clipart.png'
          case 'application/pdf':
            return 'https://cdn1.iconfinder.com/data/icons/adobe-acrobat-pdf/154/adobe-acrobat-pdf-file-512.png'
          case 'image/png':
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/gif':
            return 'https://cdn3.iconfinder.com/data/icons/faticons/32/picture-01-512.png'
          default:
            return 'https://cdn4.iconfinder.com/data/icons/48-bubbles/48/12.File-512.png'
        }
      })
    },
    fullText: function() {
      return (this.card.content.title ? this.card.content.title + '\n\n' : '') + this.text + this.listCards.map(function(listCard) {
        return '\n- ' + listCard.content.description
      })
    },
    fontSize: function() {
      // const self = this
      // return 16 + 2 * Math.floor(Math.min(5, 100 / (self.text.length))) + 'px'
      return 16 + 'px'
    }
  },
  watch: {
    data: {
      handler: function(val) {
        console.log('data data')
        console.log(this.editing)
        if (!this.editing) this.syncData()
      },
      deep: true
    },
    editing: function(val) {
      const self = this
      if (val)
        self.listCards.forEach(function(listCard) {
          self.tempListCards[listCard.objectID] = JSON.parse(JSON.stringify(listCard))
        })
    }
  },
  created: function() {
    log.debug(this.data.objectID)
    this.syncData()
    if (this.data.newlyCreated)
      this.editing = true
  },
  methods: {
    syncData: function() {
      this.card = JSON.parse(JSON.stringify(this.data))
    },
    linkClick: function(event) {
      const self = this
      if (event.srcElement.nodeName === 'A') {
        event.stopPropagation()
        var myRegexp = /\[.*?\]\((.*?)\)/g
        var match = myRegexp.exec(self.text)
        const toLayerKeys = []
        while (match != null) {
          toLayerKeys.push(match[1].replace('#', ''))
          match = myRegexp.exec(self.text)
        }
        const data = {
          // type: 'link',
          toURI: event.srcElement.hash.replace('#', ''),
          fromPos: self.position,
          toLayerKeys: toLayerKeys
        }
        data.toPos = [ data.fromPos[0] + 1, data.toLayerKeys.indexOf(data.toURI) ]
        this.$emit('showCard', data)
      }
    },
    cardMouseover: function() {
      const self = this
      this.$emit('cardMouseover', self.card)
    },
    cardMouseout: function() {
      const self = this
      this.$emit('cardMouseout', self.card)
    },
    cardClick: function() {
      const self = this
      console.log('cardClick')
      if (!this.editing) this.$emit('cardClick', self.card)

      const data = {
        // type: 'select',
        // toURI: event.srcElement.hash.replace('#', ''),
        fromPos: self.position,
        toPos: self.position,
        // fromDOM: getCardDOM(triggerTarget),
        // toLayerKeys: toLayerKeys
      }
      this.$emit('showCard', data)
    },
    cardletClick: function(card) {
      if (!this.editing) this.$emit('cardClick', card)
    },
    createCard: function() {
      // Hi
    },
    editCard: function() {
      this.editing = true
    },
    deleteCard: function() {
      this.$emit('deleteCard', this.card.objectID)
    },
    cancelEdit: function() {
      this.syncData()
      this.editing = false
      // self.tempListCards = {} ????
      setTimeout(function() {
        self.syncData() // Shouldn't be necessary if data were properly being wtached deeply
      }, 10)
    },
    saveEdit: function() {
      const self = this
      self.editing = false
      setTimeout(function() {
        console.log('self.card.content.title')
        console.log(self.card.content.title)
        self.card.title = self.card.content.title
        if (self.card.sources.filter(source => source.name === 'Journalist').length === 0)
          self.card.sources.push({
            type: 'author',
            name: 'Journalist'
          })
        console.log(self.card.title)
        self.card.content.listCards = self.listCards
        self.listCards.forEach(function(listCard) {
          self.tempListCards[listCard.objectID] = listCard
        })
        self.$emit('updateCard', self.card, function(data) {
          self.tempListCards = {}
          // self.syncData() // Shouldn't be necessary if data were properly being wtached deeply
        }, function(e) {
          console.log(e)
          self.tempListCards = {}
        })
      }, 5)
    },
    addListItem: function(card) {
      console.log(card)
      const self = this
      if (!card)
        card = {
          objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
          intent: 'storeMemory',
          content: {
            description: '',
          }
        }
      self.tempListCards[card.objectID] = card
      if (!self.card.content.listItems) Vue.set(self.card.content, 'listItems', [])
      self.card.content.listItems.push(card.objectID)
    },
    removeListItem: function(data) {
      const listIndex = this.card.content.listItems.indexOf(data.objectID) // Doesn't account for same item appearing twice in list
      this.card.content.listItems.splice(listIndex, 1)
    },
    toggleListSearch: function() {
      this.showListSearch = !this.showListSearch
    },
    togglePending: function() {
      this.showPending = !this.showPending
    },
    copy: function(e) {
      // The v-clipboard directive has already copied the text from the card - this function just shows the alert
      this.$emit('copy')
    },
    reaction: function(reaction) {
      const self = this
      self.$emit('reaction', { reaction: reaction, card: self.card })
      self.reacted = true
    }
  }
}

String.prototype.trunc = function(start, length, useWordBoundary) {
  if (this.length <= length) return this
  var subString = this.substr(start, length - 1)
  return (start > 0 ? '...' : '') + (useWordBoundary
    ? subString.substr(0, subString.lastIndexOf(' '))
    : subString) + '...'
}
</script>

<style lang="scss">

  @import '../../styles/main.scss';

  .card {
    @extend .block;
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 10px calc(50% - 203px);
    width: calc(100% - 50px);
    max-width: 380px;
    padding: 0;
    // border-radius: 10px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    background: white;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      @include blockShadow(2);

      .buttons-top-right {
        display: block;
      }
    }

    &.highlight {
      box-shadow: 0px 0px 30px rgba(100, 84, 244, 0.5);
    }
    &.highlight:hover {
      box-shadow: 0px 0px 30px rgba(100, 84, 244, 0.8);
    }
    &.full {
      a.file {
        margin-bottom: 10px;
      }
    }

    .updating {
      opacity: 0.5;
    }
    .buttons-top-right {
      display: none;
      position: absolute;
      top: 5px;
      right: 5px;
      // margin: -5px -5px 10px 20px;
      button {
        padding: 6px 12px;
        margin: 2px;
        font-size: 12px;
        box-shadow: none;
        opacity: 0.7;
        display: inline-block;

        &:hover {
          opacity: 1;
          box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
          img {
            opacity: 1;
          }
        }
        img {
          opacity: 0.5;
          display: inline-block;
        }
      }
    }
    button {
      &.left {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        margin-right: -2px;
      }
      &.delete:hover {
        background: #ffaaaa;
      }
      &.right {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        margin-left: -2px;
      }
      &.cancel {
        background: #ffb6c9;
      }
      &.save {
        background: #b8ecc0;
      }
      &.selected {
        background: #ddd;
      }

      .small {
        font-size: 0.8em;
        padding: 0.5em 1em;
      }
    }
    .label {
      margin: 5px 5px 0 5px;
      padding: 5px;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: bold;
      color: #aaa;

      .top-hit, .top-hit svg {
        color: rgb(100, 84, 244);
      }
      .fa-icon {
        color: #aaa;
      }
    }
    img.icon {
      height: 1em;
      margin: 0 4px -1px 0px;
      padding: 0;
    }
    p, img, ol, .editable {
      margin: 5px;
      padding: 5px;
    }
    ol {
      padding-left: 20px;

      li {
        padding-left: 5px;
      }
    }
    .editing.editable.editing {
      margin: 3px;
    }
    p {
      white-space: pre-wrap;
    }
    .main {
      margin: 5px;
      padding: 5px;
      min-height: 60px;

      .content {
        // @extend .blockSpacing;
        // margin: 5px;
        // padding: 5px;

        strong {
          font-weight: 800;
          font-style: normal;
          color: #777;
        }
        p {
          line-height: 1.5;
        }
        a {
          text-decoration: inherit;
          padding: 0 4px;
          border: 2px solid $explaainLink;
          background-color: $explaainLink;
          color: inherit;
          border-radius: 4px;

          &:hover {
            color: white;
            border: 2px solid $savvy;
            background-color: $savvy;

            strong {
              color: white;
            }
          }
        }
        img {
          max-width: calc(100% - 10px);
          border-radius: 5px;
        }
        .title {
          font-weight: bold;
          font-size: 1.2em;
        }
      }
    }
    .list {
      margin: 20px 0 10px;
    }
    .extractedFrom {
      font-size: 14px;
      color: #999;
      font-style: italic;
    }
    .extractedFrom a {
      color: #999;
      font-weight: bold;
      text-decoration: none;
    }
    .extractedFrom a:hover {
      border-bottom: 4px solid rgb(255,211,35);
    }
    a.file {
      display: block;
      margin: 0;
      padding: 10px;
      box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
      -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
      background: #f5f5f5;
      transition: background-color .3s;
      color: inherit;
      text-decoration: inherit;

      &:hover {
        background: #eee;
      }

      img {
        height: 40px;
        float: left;
        margin: 0 10px;
      }
      h4, h5 {
        margin: 3px;
      }
      h4 {
        font-size: 1em;

        strong {
          font-weight: 900;
          color: #555;
          font-style: normal;
        }
        p {
          margin: 0;
          padding: 0;
        }
      }
    }
    footer {
      margin: 5px;
      padding: 5px;
      min-height: 20px;

      .sources {
        margin: 5px;
        padding: 5px;
        font-size: 14px;

        a {
          color: inherit;
          text-decoration: none;
          font-weight: bold;

          &:hover {
            color: $savvy;
          }
        }
      }

      .buttons {
        // position: absolute;
        bottom: 15px;
        left: 20px;
        margin: 10px 20px -15px 2px;
        padding: 6px 12px;

        &.reaction {
          position: relative;
          left: auto;
          margin: 30px 0 10px;
          text-align: center;
          font-size: 14px;

          button {
            margin: 5px 5px 10px;
            font-size: 24px;
            padding: 4px 10px 0;
          }
        }
      }
    }
    .list section.buttons {
      margin: 10px 0;
    }
    .buttons button {
      padding: 6px 12px;
      margin: -2px;
      font-size: 12px;
    }
    .buttons button:focus {
      outline:none;
    }
    .pending {
      color: grey;
      font-size: 0.8em;
    }
    .footer-logo {
      position: absolute;
      margin: 5px;
      padding: 5px;
      bottom: 10px;
      right: 15px;
      font-size: 14px;
      font-weight: bold;
      color: #aaa;
    }
  }
  .sidebar .card {
    margin: 10px;
  }
  // .card.shadow {
  //   width: calc(100% - 70px);
  //   box-shadow: 0px 0px 30px rgba(150,150,150,0.5);
  //   border: none;
  // }
  @media (min-width: 600px) {
    .explorer:not(.sidebar) .main .card:not(.cardlet) {
      width: calc(50% - 35px);
      margin: 10px;
    }
  }
  @media (min-width: 900px) {
    .explorer:not(.sidebar) .main .card:not(.cardlet) {
      width: calc(33.3% - 40px);
    }
  }
  @media (min-width: 1450px) {
    .explorer:not(.sidebar) .main .card:not(.cardlet) {
      width: calc(25% - 30px);
    }
  }

  .editing:not(.non-editable) :not(.non-editable) .editable:not(.non-editable), .editing:not(.non-editable) > .editable:not(.non-editable) {
    border: 2px dashed lightgrey;
    border-radius: 4px;
    color: black;
    cursor: text;
  }

  button.approve {
    margin: 20px 0 0 0;
    color: green;

    svg {
      color: green;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/explorer/card.vue